export default __webpack_public_path__ + "static/media/no-answer.2c5dcc1a.svg";